// extracted by mini-css-extract-plugin
export default {"paymentModal":"knI0tiRF","header":"OlmPb7L4","ant-modal-header":"ant-modal-header","ant-modal-body":"ant-modal-body","contentRow":"mT8amitq"};